import React, { FC, useCallback, useState } from "react";
import CheckboxField from "../../common/form/fields/CheckboxField";

const AlterType: FC<{ value: "edit" | "move" | "rotate" | null; onChange: (field: "edit" | "move" | "rotate") => void }> = (props) => {
  const [value, setValue] = useState<"edit" | "move" | "rotate">(props.value || "edit");
  const handleChange = useCallback(
    (key: "edit" | "move" | "rotate") => {
      setValue(key);
      props.onChange(key);
    },
    [props]
  );

  return (
    <div
      style={{
        position: "fixed",
        top: 70,
        paddingLeft: 5,
        paddingRight: 5,
        paddingTop: 8,
        left: 0,
        border: 0,
        fontSize: 13,
        zIndex: 2000,
        textAlign: "center",
        width: "100%",
      }}
    >
      {["Edit", "Move", "Rotate"].map((type) => (
        <span
          key={type}
          style={{
            background: "rgba(255,255,255,0.7)",
            margin: 3,
            padding: 3,
            paddingTop: 10,
            paddingBottom: 8,
            borderRadius: 3,
            border: "solid 1px white",
          }}
        >
          {type}{" "}
          <CheckboxField
            field={{
              key: type.toLowerCase(),
              value: value === type.toLowerCase(),
              label: "",
              type: "checkbox",
            }}
            onChange={handleChange as (field: string) => void}
          />
        </span>
      ))}
    </div>
  );
};
export default AlterType;
